<style scoped lang="sass">
.pool-participation-offer
  display: flex
  justify-content: space-between
  align-items: center
  background-color: var(--gold)
  color: white
  padding: 0.5rem
  img
    height: 1.5rem
  .actions
    display: flex
    flex-direction: column
    align-items: center
    .join
      font-size: 0.8rem
      margin-top: 0
    .leave
      font-size: 0.5rem
      color: white
      margin-top: 0.5rem
  >*
    margin-right: 0.5rem
    margin-top: 0
    &:last-child
      margin-right: 0
</style>
<template>
  <div>
    <div class="pool-participation-offer" v-for="offer in offers">
      <img src="images/icon-stop.svg">
      <div>
        You're invited to {{offer.pool.owner.short_informal_name}}'s pool for {{offer.pool.tournament.name}}
      </div>
      <div class="actions">
        <a href="#" @click.prevent="join(offer)" class="button empty inline join">JOIN</a>
      </div>
    </div>
  </div>
</template>
<script>
import {mapActions,mapGetters}      from 'vuex';

import api                          from '../api';

export default {
  name: 'PoolParticipationOffers',
  data() {
    return {
    };
  },
  created() {
    this.loadPoolParticipationOffers();
  },
  computed: {
    ...mapGetters('poolParticipationOffers', ['offers'])
  },
  methods: {
    ...mapActions('poolParticipationOffers', ['loadPoolParticipationOffers']),
    join(offer) {
      api.PoolParticipationOffer.destroy({params: {id: offer.participation_verification}})
        .then(() => this.loadPoolParticipationOffers())
        .then(() => this.$router.push({name: 'pool', params: {id: offer.pool.id}}));
    }
  }
};
</script>
